import * as React from 'react';

export const accordionFaq = [
  {
    title: 'Почему так дорого?',
    description:
      <>
        <p>Стоимость курса складывается из времени и сил специалистов, которые трудились над его созданием. Мы проделали большую методическую работу: собрали, структурировали и проверили материал для занятий, разработали и проиллюстрировали пособие для тренировки чтения, создали интерактивные упражнения. Мы уверены в качестве материалов курса и в его эффективности.
        </p>
        <p>Курс будет вам доступен в течение 4 лет, вы получите знания, которые можно применить многократно, что позволит значительно сэкономить, если в семье несколько детей.
        </p>
      </>
  },
  {
    title: 'Сколько времени займёт прохождение курса?',
    description:
      <>
        <p>Посмотреть видеоуроки и ознакомиться с дополнительными материалами можно за 4,5 часа. Но чтобы осмыслить информацию, разобраться в рекомендациях, внимательно просмотреть материалы и перечитать тексты к урокам, понадобится больше времени — всё зависит от вашей скорости восприятия информации.
        </p>
        <p>Важно понимать: для того, чтобы начать применять наши рекомендации и упражнения в работе с детьми, необходимо посмотреть видеоуроки и вникнуть в методику. На это понадобится немного времени и усилий.
        </p>
        <p>На выполнение одного из 15 уроков на платформе ребёнку потребуется примерно 40 минут (напомним, что в каждом уроке по 15 интерактивных упражнений).
        </p>
        <p>Чтобы прочитать одну главу из пособия и выполнить 6 заданий, нужно примерно 35 минут. Обратите внимание, что у всех детей разная скорость работы, здесь мы исходим из средних показателей — показатели вашего ребёнка могут отличаться как в меньшую, так и в большую сторону.
        </p>
      </>
  },
  {
    title: 'Как быстро будет результат?',
    description:
      <p>Если вы будете каждый день заниматься с ребёнком, используя наши рекомендации, через месяц скорость чтения возрастёт в 1,5–2 раза, закрепится навык запоминания ключевых мыслей текста, повысится концентрация внимания.</p>
  },
  {
    title: 'А я справлюсь, если я не педагог?',
    description:
      <p>В наших обучающих роликах мы даём подробные рекомендации именно для родителей без педагогического образования. Если во время занятий у вас возникнут затруднения, вы всегда можете задать вопрос в чате поддержки и получить экспертный ответ.</p>
  },
];
